/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createSquare } from '../../factoriesAny.js';
export var squareDependencies = {
  typedDependencies,
  createSquare
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesSquare.generated.js
// module id = null
// module chunks = 